<div *ngIf="confirmPopup" class="modal fade" tabindex="-1" role="dialog" [config]="{ show: true, backdrop: 'static', keyboard: false }"
  bsModal #autoShownModal="bs-modal">
  <div class="custom-theme-modal modal-dialog modal-md modal-dialog-centered {{inputClass}}">
    <div class="modal-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
